import { type Heartbeat } from '../../../common/types';

export function isNumeric(input: string): boolean {
	// https://www.ascii-code.com
	for (let i = 0; i < input.length; i++) {
		const ascii = input.charCodeAt(i);
		if (ascii < 48 || ascii > 57) {
			return false;
		}
	}

	return true;
}

export function getIntervalUnitOptions(): {
	label: Heartbeat['intervalUnit'];
	value: Heartbeat['intervalUnit'];
}[] {
	return [
		{ label: 'minutes', value: 'minutes' },
		{ label: 'hours', value: 'hours' },
		{ label: 'days', value: 'days' },
	];
}
